import React from 'react';
import { Book, CheckCircle } from 'lucide-react';

const TermsOfService = ({ onAccept, onDecline, readOnly = false, onClose }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-center mb-6">
          <Book className="w-12 h-12 text-indigo-600 mr-3" />
          <h1 className="text-3xl font-bold text-gray-800">Terms of Service</h1>
        </div>

        <div className="space-y-6 text-gray-700">
          <p className="text-sm text-gray-500">Last Updated: December 27, 2024</p>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">1. Acceptance of Terms</h2>
            <p>By accessing and using Vibely ("the Platform"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these Terms of Service, please do not use the Platform.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">2. Service Description</h2>
            <p>Vibely is a book review exchange platform that connects authors with readers. Authors can upload their books and offer coins to reviewers. Reviewers can claim books, read them, and submit honest reviews on Amazon in exchange for coins.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">3. User Accounts</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>You must be at least 18 years old to use this Platform</li>
              <li>You are responsible for maintaining the confidentiality of your account</li>
              <li>You are responsible for all activities that occur under your account</li>
              <li>You must provide accurate and complete information when creating an account</li>
              <li>One person may not create multiple accounts</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">4. Review Guidelines</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>All reviews must be honest and reflect your genuine opinion</li>
              <li>Reviews must comply with Amazon's Terms of Service</li>
              <li>You must actually read the book before submitting a review</li>
              <li>Reviews must be at least 15 words and provide meaningful feedback</li>
              <li>Fake, dishonest, or manipulated reviews are strictly prohibited</li>
              <li>Violating these guidelines may result in account suspension or termination</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">5. Virtual Currency (Coins)</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Coins are virtual currency used within the Platform</li>
              <li>Coins have no real-world monetary value</li>
              <li>Coins cannot be exchanged for cash or refunded</li>
              <li>Authors pay coins to reviewers for completed reviews</li>
              <li>We reserve the right to adjust coin balances in case of fraudulent activity</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">6. Contact Information</h2>
            <p>For questions about these Terms, please contact us through the Customer Support feature in the app.</p>
          </section>
        </div>



        {/* ✅ UPDATED: Different buttons based on readOnly mode */}
        {readOnly ? (
          <div className="mt-8">
            <button
              onClick={onClose}
              className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 transition"
            >
              Close
            </button>
          </div>
        ) : (
          <div className="mt-8 flex gap-4">
            <button
              onClick={onDecline}
              className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-400 transition"
            >
              Decline
            </button>
            <button
              onClick={onAccept}
              className="flex-1 bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 transition flex items-center justify-center gap-2"
            >
              <CheckCircle className="w-5 h-5" />
              I Accept
            </button>
          </div>

          
        )}
      </div>
    </div>
  );
};


export default TermsOfService;